import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Modal, Select, TextInput } from "risa-oasis-ui_v2";

interface AddMembersModalProps {
  onSave: (inviteMemberModel: MemberModel) => void;
  facilityId: string;
}

export interface MemberRole {
  id: string;
  name: string;
  tasks?: TaskModel[];
}

export interface MemberModel {
  email: string;
  name: string;
  facilityId: string;
  roleId: string;
  status: string;
  isAdmin: boolean;
  id?: string;
}

export interface TaskModel {
  name: string;
}

const initialName = "";
const initialEmail = "";
const initialRole = "";

export default function AddMembersModal(props: AddMembersModalProps) {
  const CustomModal = Modal;
  const [name, setName] = useState(initialName);
  const [email, setEmail] = useState(initialEmail);
  const [role, setRole] = useState(initialRole);
  const roleOptions = [
    {
      id: "nurse",
      name: "Nurse",
    },
    {
      id: "medical_coordinator",
      name: "Medical Coordinator",
    },
    {
      id: "medical_director",
      name: "Medical Director",
    },
  ];

  const handleSave = () => {
    const memberModel: MemberModel = {
      name: name,
      email: email,
      roleId: role,
      isAdmin: false,
      status: "invited",
      facilityId: props.facilityId,
    };
    props.onSave(memberModel);
    resetData();
  };

  function resetData() {
    setName(initialName);
    setEmail(initialEmail);
    setRole(initialRole);
  }

  function onChange(data) {
    switch (data.name) {
      case "member-name-id":
        setName(data.value);
        break;
      case "member-email-id":
        setEmail(data.value);
        break;
      case "member-role-id":
        setRole(data.value);
        break;
    }
  }

  useEffect(() => {
    setName(initialName);
    setEmail(initialEmail);
  }, []);

  return (
    <>
      <CustomModal
        dialogId={"add-member-id"}
        onSave={handleSave}
        onCancel={resetData}
        title="Invite Member"
        saveButtonText={"Save"}
        cancelText={"Cancel"}
        disableSave={name === "" || email === "" || role === ""}
      >
        <div>
          <div className="member-detail-container">
            <form id="member-role-info">
              <TextInput
                id="member-name-id"
                error=""
                label="Name"
                placeholder="Enter the member's name"
                onChange={onChange}
                resetField={name === ""}
                required={true}
              />
              <TextInput
                defaultValue={initialEmail}
                id="member-email-id"
                error=""
                label="Email"
                placeholder="Enter the member's email"
                onChange={onChange}
                resetField={email === ""}
                required={true}
              />
            </form>
            <Select
              id="member-role-id"
              label="Role"
              placeholder="Select the member's role"
              options={roleOptions.map((role) => {
                return { value: role.id, label: role.name };
              })}
              onOptionChange={onChange}
              defaultValue={""}
              required={true}
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
}

AddMembersModal.propTypes = {
  onSave: PropTypes.func.isRequired,
};
